export const shortcutActions = {
  'shortcut': {
    eventType: 'engagement',
    entityTypes: ['ui'],
    eventData: {
      uiType: 'button',
    },
    expects: ['value', 'label']
  }
}
